/* This is a util to get the event target, wether it comes from the lightDOM or shadowDOM - this requires the Shadow DOM to be of type 'open' */
export const getEventTarget = (e) => e.composedPath()[0];
